export const nameReg =
  /^(?:[\u4e00-\u9fa5·]{2,16}|[a-zA-Z]{1}[a-zA-Z\s]{0,20}[a-zA-Z]{1})$/;
export const phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
